export const SUBSCRIPTION = 'SUBSCRIPTION'
export const SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS'
export const APPROVE_SUBSCRIPTION = 'APPROVE_SUBSCRIPTION'
export const UPGRADE_SUBSCRIPTION = 'UPGRADE_SUBSCRIPTION'
